export interface PlanData {
  name: string;
  cost: string;
  price: string;
}

export const plansData: PlanData[] = [
  {
    name: "Paid Plan 1",
    cost: "€ 239.00",
    price: "€ 399.00",
  },
  {
    name: "Paid Plan 2",
    cost: "€ 349.00",
    price: "€ 299.00",
  },
];

